/**
 * Lazy video start
 * Videos inside [data-lazy-video] are rendered without `autoplay` (autoplay downloads the whole file at page load,
 * even for hidden or far-below-the-fold videos). Each video is played when it comes near the viewport and paused
 * when it leaves it (a video started with play() is not paused off screen by the browser, unlike native autoplay).
 * A video hidden with CSS has no box, so it never intersects and never downloads.
 */
(function () {
  if (window.lazyVideoInitialized) return;
  window.lazyVideoInitialized = true;

  const playVideo = video => {
    const playPromise = video.play();
    if (playPromise !== undefined) playPromise.catch(() => {});
  };

  const observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) playVideo(entry.target);
              else entry.target.pause();
            });
          },
          { rootMargin: '300px 0px' }
        )
      : null;

  const watchVideos = root => {
    root.querySelectorAll('[data-lazy-video] video').forEach(video => {
      if (video.dataset.lazyVideoWatched) return;
      video.dataset.lazyVideoWatched = 'true';
      if (observer) observer.observe(video);
      else playVideo(video);
    });
  };

  watchVideos(document);
  document.addEventListener('shopify:section:load', event => watchVideos(event.target));
})();
